import styles from './IndexPage.module.scss'
import { AreaPageHeader } from '@/components/pages/AreaPageModern/components/AreaPageHeader/AreaPageHeader'
import { Button, Icon, Input } from '@/components'
import { RootState } from '@/store'
import getLinkHref from '@/helpers/getLinkHref'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import Error from '@/components/Error'
import CloseIcon from '@/assets/icons/CloseIcon'
import SearchIcon from '@/assets/icons/SearchIcon'
import cn from 'classnames'
import { MobileAppLinks } from '@/components/MobileAppLinks/MobileAppLinks'

const IndexPage = () => {
  const reduxState = useSelector<RootState, RootState>(state => state)
  const router = useRouter()
  const areasState = reduxState.stages.areas
  const areas = areasState.data && Array.isArray(areasState.data) ? areasState.data : null
  const isError = !areas || areas.length === 0 || areasState.error
  const [parkingObj, setParkingObj] = useState('')
  const [searchParking, setSearchParking] = useState('')
  const [openParkingList, setOpenParkingList] = useState(false)

  const filteredAreas = areas
    ? areas.filter(area => area.name.toLowerCase().includes(searchParking.toLowerCase()))
    : []

  const lkHref = typeof window !== 'undefined' ? `${window.location.origin}/lk/` : '/lk'

  return (
    <div className={styles.page}>
      <div className={styles.page__content}>
        {/*TODO: сделать AreaPageHeader универсальным переиспользуемым компонентом. Импортировать из /components*/}
        <AreaPageHeader isIndexPage={true} />
        <section className={styles.promotion}>
          <div className={styles.promotionWrapper}>
            <h1 className={styles.title}>
              Скачайте приложение и&nbsp;оплачивайте парковку без паркоматов
            </h1>
            <p className={styles.description}>
              Находите парковки, следите за временем и&nbsp;оплачивайте абонементы
            </p>
            <div className={styles.containerButtons}>
              <MobileAppLinks />

              <button
                onClick={() => setOpenParkingList(prev => !prev)}
                className={styles.buttonPayment}
              >
                Оплатить онлайн
              </button>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={lkHref}
                className={styles.buttonCabinet}
              >
                Войти в личный кабинет
              </a>
            </div>
          </div>
        </section>
        <section
          onClick={() => {
            if (openParkingList) {
              setOpenParkingList(!openParkingList)
            }
          }}
          className={cn(styles.section, { [styles.section__modalOpen]: openParkingList })}
        >
          {!isError ? (
            <div
              className={cn(styles.containerContent, {
                [styles.containerContent__modalOpen]: openParkingList,
              })}
              onClick={e => e.stopPropagation()}
            >
              <div
                onClick={() => setOpenParkingList(prev => !prev)}
                className={styles.modalCloseIcon}
              >
                <Icon name={'modal-close-icon'} />
              </div>
              <h3 className={styles.modalTitle}>Выберите название или адрес парковки</h3>
              <div className={styles.containerInput}>
                <div className={styles.containerSearchIcon}>
                  <SearchIcon />
                </div>
                <Input
                  value={searchParking}
                  onChange={e => {
                    setSearchParking(e.target.value)
                    setParkingObj('')
                  }}
                  placeholder={'Поиск'}
                />
                <div
                  onClick={() => {
                    setSearchParking('')
                    setParkingObj('')
                  }}
                  className={styles.containerCloseIcon}
                >
                  <CloseIcon />
                </div>
              </div>

              {!parkingObj && (
                <ul className={styles.parkingList}>
                  {filteredAreas?.map(area => {
                    const splitter = area.name.indexOf(',')
                    const name = splitter === -1 ? area.name : area.name.slice(0, splitter + 1)
                    const rest = splitter === -1 ? '' : area.name.slice(splitter + 1)

                    return (
                      <div
                        key={area.link}
                        className={styles.parkingName}
                        onClick={() => {
                          setSearchParking(area.name)
                          setParkingObj(area.link)
                        }}
                      >
                        {name}
                        {rest && <span>{rest}</span>}
                      </div>
                    )
                  })}
                </ul>
              )}
              <div className={styles.containerButton}>
                <Button
                  className={styles.button}
                  disabled={!parkingObj}
                  onClick={() => {
                    const pathname = new URL(parkingObj).pathname // "/tomsk"
                    const lastSegment = pathname.split('/').pop()
                    const hrefMainPage = getLinkHref({ type: 'area', data: { id: lastSegment } })
                    router.push(hrefMainPage)
                  }}
                >
                  Продолжить
                </Button>
              </div>
            </div>
          ) : (
            <Error statusCode={500} />
          )}
        </section>
      </div>
    </div>
  )
}

export default IndexPage
